var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import dashboard from './dashboard';
import dateTime from './date-time';
import errors from './errors';
import forums from './forums';
import global from './global';
import home from './home';
import locked from './locked';
import mainNav from './main-nav';
import masquerade from './masquerade';
import notifications from './notifications';
import onboarding from './onboarding';
import profile from './profile';
import profileedit from './profileedit';
import setting from './setting';

export default _extends({}, dashboard, dateTime, errors, forums, global, home, locked, mainNav, masquerade, notifications, onboarding, profile, profileedit, setting);


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/index.js